import React, { Component } from "react";
import SelectPoules from "../../components/schedule/SelectPoules";
import { languages } from "../../constants/languages";

class SelectPoulesContainer extends Component {
  render() {
    let options = [
      {
        value: "all",
        label: languages.schedule.allPoulesBrackets,
      },
    ]
      .concat(this.props.pouleOptions)
      .concat(this.props.bracketOptions)
      .sort((a, b) => {
        if (a.division > b.division) {
          return 1;
        } else if (a.division < b.division) {
          return -1;
        } else if (a.fase > b.fase) {
          return 1;
        } else if (a.fase < b.fase) {
          return -1;
        } else if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else {
          return a.num - b.num;
        }
      });

    return (
      <SelectPoules
        handleSelectChange={this.props.handleSelectChange}
        value={this.props.value}
        selectedValue={this.props.selectedValue}
        options={options}
        tournament={this.props.tournament}
      />
    );
  }
}

export default SelectPoulesContainer;
